import script from "./NewsInvestors.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsInvestors.vue?vue&type=script&setup=true&lang=js"

import "./NewsInvestors.vue?vue&type=style&index=0&id=31376ff6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31376ff6"]])

export default __exports__